"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastUpdatedFieldLogic = void 0;
const intl_1 = require("../../locale/intl");
const texts_1 = require("../../texts");
const base_created_updated_fieldtype_1 = require("../base-fields/base-created-updated.fieldtype");
class LastUpdatedFieldLogic extends base_created_updated_fieldtype_1.BaseCreatedUpdatedFieldType {
    constructor() {
        super(...arguments);
        this.name = "lastupdatedfield";
        this.label = (0, intl_1.$t)(texts_1.createUpdateFieldText.last_updated);
        this.icon = "last-updated";
        this.iconColor = "#FF5757";
        this.searchSynonyms = [
            (0, intl_1.$t)(texts_1.createUpdateFieldText.change),
            (0, intl_1.$t)(texts_1.createUpdateFieldText.by),
        ];
    }
}
exports.LastUpdatedFieldLogic = LastUpdatedFieldLogic;
